var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.944,
    height: 28.937,
    viewBox: "0 0 28.944 28.937",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M14.47,9.287a7.419,7.419,0,1,0,7.419,7.419A7.407,7.407,0,0,0,14.47,9.287Zm0,12.242a4.823,4.823,0,1,1,4.823-4.823A4.832,4.832,0,0,1,14.47,21.53ZM23.923,8.984a1.73,1.73,0,1,1-1.73-1.73A1.726,1.726,0,0,1,23.923,8.984Zm4.914,1.756A8.564,8.564,0,0,0,26.5,4.677a8.62,8.62,0,0,0-6.063-2.337c-2.389-.136-9.55-.136-11.939,0A8.608,8.608,0,0,0,2.434,4.67,8.592,8.592,0,0,0,.1,10.733c-.136,2.389-.136,9.55,0,11.939a8.564,8.564,0,0,0,2.337,6.063A8.631,8.631,0,0,0,8.5,31.073c2.389.136,9.55.136,11.939,0A8.564,8.564,0,0,0,26.5,28.736a8.62,8.62,0,0,0,2.337-6.063c.136-2.389.136-9.543,0-11.933Zm-3.086,14.5A4.883,4.883,0,0,1,23,27.987c-1.9.755-6.425.581-8.53.581s-6.631.168-8.53-.581a4.883,4.883,0,0,1-2.751-2.751c-.755-1.9-.581-6.425-.581-8.53s-.168-6.631.581-8.53A4.883,4.883,0,0,1,5.94,5.426c1.9-.755,6.425-.581,8.53-.581S21.1,4.677,23,5.426A4.883,4.883,0,0,1,25.75,8.177c.755,1.9.581,6.425.581,8.53S26.506,23.338,25.75,25.236Z",
    transform: "translate(0.005 -2.238)",
    fill: "#2eafbe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon-instagram.0b209afdd1457f356c678b0b9cae615b.svg";
export { ForwardRef as ReactComponent };